export const CategoriasEnlacesActionTypes = {
  API_RESPONSE_SUCCESS: '@@categorias-enlaces/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@categorias-enlaces/API_RESPONSE_ERROR',

  GET_CATEGORIA_ENLACES: '@@categorias-enlaces/GET_CATEGORIA_ENLACES',
  LIST_CATEGORIAS_ENLACES: '@@categorias-enlaces/LIST_CATEGORIAS_ENLACES',
  ADD_CATEGORIA_ENLACES: '@@categorias-enlaces/ADD_CATEGORIA_ENLACES',
  UPDATE_CATEGORIA_ENLACES: '@@categorias-enlaces/UPDATE_CATEGORIA_ENLACES',
  DELETE_CATEGORIA_ENLACES: '@@categorias-enlaces/DELETE_CATEGORIA_ENLACES',

  RESET: '@@categorias-enlaces/RESET'
}
